import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../api/baseQuery";

/** "off": nothing to wait for. "syncing": a pull was requested and hasn't completed. "ready": it has. */
export type PatientSyncState = "off" | "syncing" | "ready";

export interface PatientSyncStatus {
  state: PatientSyncState;
}

export const patientSyncApi = createApi({
  reducerPath: "patientSyncApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getPatientSyncStatus: builder.query<PatientSyncStatus, void>({
      query: () => "/rpa/patients/sync-status/",
    }),
  }),
});

export const { useGetPatientSyncStatusQuery } = patientSyncApi;
